import React, { useCallback, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import ApplicationShell from "./ApplicationShell";
import { getWsmNavigation } from "./wsmNavigation";
import { authActions } from "../../features/auth/authSlice";
import { SuperOrgContext } from "../../contexts/SuperOrgContextProvider";
import { PackService } from "../../services/packService";

const getActivePath = (pathname) => {
  if (pathname.startsWith("/packs/create")) return "/packs/resume";
  if (pathname.startsWith("/view/")) return "/packs/register";
  return pathname;
};

const AuthenticatedAppShell = () => {
  const authUser = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { super_organisation_id: selectedOrganisationId } = useContext(SuperOrgContext);
  const { pathname } = useLocation();
  const searchPacks = useCallback(
    (query) => PackService.searchPacks(query, selectedOrganisationId || authUser?.organisation_id),
    [authUser?.organisation_id, selectedOrganisationId]
  );

  return (
    <ApplicationShell
      activePath={getActivePath(pathname)}
      items={getWsmNavigation(authUser)}
      onLogout={() => dispatch(authActions.logout())}
      onPackSelect={(pack) => navigate(`/view/${pack.id}`)}
      onSearchPacks={searchPacks}
      user={{ name: authUser?.name || "User", role: authUser?.roles?.[0]?.name || "Worksite Manager user" }}
    >
      <Outlet />
    </ApplicationShell>
  );
};

export default AuthenticatedAppShell;
